import {
  ColumnTable,
  OutlinedSelectOptionType,
  OutlinedSelect,
  Button,
} from '@octano/global-ui';
import { useCallback } from 'react';
import { DegreeDocument } from '../types';
import ValidationFileChip from './ValidationFileChip';

export function useDegreeDocumentsColumns(texts: {
  title: string;
  selectOptions: {
    rejected: string;
    approved: string;
    pending: string;
  };

  table: {
    noResults: string;
    headers: {
      name: string;
      documentName: string;
      load: string;
      state: string;
    };
  };
}) {
  const options: OutlinedSelectOptionType[] = [
    {
      label: texts.selectOptions.rejected,
      value: 'rejected',
      icon: { name: 'error', color: 'danger' },
    },
    {
      label: texts.selectOptions.approved,
      value: 'approved',
      icon: { name: 'success', color: 'success' },
    },
  ];

  const handleDownloadFile = useCallback((file: any) => {
    if (!file?.url) {
      return;
    }
    window.open(file?.url, '_blank');
  }, []);

  const columns: ColumnTable<DegreeDocument>[] = [
    {
      headerText: 'Tipo documento',
      columnName: 'name',
      thClassName: 'text-center',
      tdClassName: 'text-center',
      width: '15%',
    },
    {
      headerText: 'Nombre',
      columnName: 'documentName',
      thClassName: 'text-center',
      tdClassName: 'text-center',
      width: '35%',
      cellFormat: ({ row }) => {
        return (
          !!row.file && (
            <div
              className="w-full mt-3 d-flex flex-wrap align-items-center justify-content-center"
              style={{ gap: 5 }}
            >
              <ValidationFileChip
                key={row.file.id.toString()}
                value={row}
                children={`${row.file.name}.${row.file.extension}`}
                onDownload={() => handleDownloadFile(row.file!)}
              />
            </div>
          )
        );
      },
    },
    {
      headerText: 'Cargar nuevo',
      columnName: 'load',
      thClassName: 'text-center',
      tdClassName: 'text-center',
      width: '15%',
      cellFormat: ({ row }) => {
        return (
          <Button
            size="md"
            text="Cargar Archivo(s)"
            icon="export"
            outlined
            disabled
            fullwidth
          />
        );
      },
    },
    {
      headerText: 'Estado',
      columnName: 'state',
      thClassName: 'text-center',
      tdClassName: 'text-center',
      width: '20%',
      cellFormat: ({ row }) => {
        return (
          <OutlinedSelect
            disabled={!row.file || !row.updateAllowed}
            name="select"
            label="Selección"
            isClearable={false}
            value={
              options.find((element) => element.value === row.status) || {
                label: 'Sin revisión',
                value: 'pending',
                icon: { name: 'warning', color: 'warning' },
              }
            }
            options={options}
          />
        );
      },
    },
  ];
  return columns;
}
